export default __webpack_public_path__ + "static/media/raya-bg.1c18d771.webp";